// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const AlertError = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M9,18 C12.2153907,18 15.1865337,16.2846093 16.7942294,13.5 C18.4019241,10.7153907 18.4019241,7.28460985 16.7942294,4.5 C15.1865337,1.71539068 12.2153907,0 9,0 C5.78461008,0 2.81346653,1.71539068 1.20577137,4.5 C-0.401923791,7.28460985 -0.401923791,10.7153907 1.20577137,13.5 C2.81346653,16.2846093 5.78461008,18 9,18 Z M12.4417971,6.75 L11.8441408,7.34765625 L10.1917971,9 L11.8441408,10.6523438 L12.4417971,11.25 L11.2500004,12.4417967 L10.6523442,11.8441404 L9.0000004,10.1917967 L7.34765665,11.8441404 L6.7500004,12.4417967 L5.55820374,11.25 L6.15585999,10.6523438 L7.80820374,9 L6.15585999,7.34765625 L5.55820374,6.75 L6.7500004,5.55820334 L7.34765665,6.15585959 L9.0000004,7.80820334 L10.6523442,6.15585959 L11.2500004,5.55820334 L12.4417971,6.75 Z"
            />
        </svg>
    );
};

export default React.memo(AlertError);
